module.exports = __webpack_public_path__ + "static/media/red-chair.df8fc54e.jpg";